import OwnableTheme from '@Theme';
import type { TextStyle } from 'react-native';
import { Pressable, StyleSheet, Text } from 'react-native';

type Props = {
  label: string;
  onPress?: () => void;
  isCurrent?: boolean;
  textStyle?: TextStyle;
};

export const ElevatorTextButton = ({
  label,
  isCurrent = false,
  onPress,
  textStyle,
}: Props) => {
  const opacity = isCurrent ? 1 : 0.5;

  return (
    <Pressable onPress={onPress} style={styles.textWrapper}>
      <Text style={[styles.text, textStyle, { opacity }]}>{label}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  text: {
    fontFamily: OwnableTheme.fonts.gilroy.semibold,
    color: OwnableTheme.colors.white,
    fontSize: 19,
  },
  textWrapper: {
    flex: 1,
    justifyContent: 'center',
  },
});
